// @ts-strict-ignore
import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {template} from './template';
import css from './index.styl?inline';
import {OrgSelectModalAttrs, OrgSelectModalState} from './types';

export class OrgSelectModal extends Component<OrgSelectModalState, OrgSelectModalAttrs> {
  static get attrsSchema(): AttrsSchema<OrgSelectModalAttrs> {
    return {
      ...super.attrsSchema,
      open: {type: `boolean`, description: `Should the modal be open?`},
      orgs: {type: `json`, default: [], description: `Org data in [{name, id}] format (can also be passed as a prop)`},
      'title-text': {type: `string`, default: `Select organization`, description: `Text shown in modal header`},
      'button-text': {type: `string`, default: `Done`, description: `Text shown in modal button`},
      'show-cancel': {type: `boolean`, description: `Should a cancel button be shown?`},
    };
  }
  get config() {
    return {
      template,
      css,
      useShadowDom: true,

      defaultState: {
        submitted: false,
        orgs: null,
      },

      helpers: {
        selectOrg: (org) => {
          this.update({submitted: true});
          this.dispatchEvent(new CustomEvent(`submit`, {detail: {value: org}}));
        },
        handleSubmit: (ev) => {
          if (ev.detail.action === `cancel`) {
            this.dispatchEvent(new CustomEvent(`change`, {detail: {state: `closed`}}));
          }
        },
      },
    };
  }

  set orgs(unsortedOrgs) {
    const orgs = unsortedOrgs.sort((a, b) => a.name.localeCompare(b.name));
    this.update({orgs});
  }

  attributeChangedCallback(attr, oldVal, newVal) {
    super.attributeChangedCallback(attr, oldVal, newVal);
    if (attr === `orgs`) {
      this.orgs = newVal;
    }
    if (attr === `open` && this.attr(`open`)) {
      this.update({submitted: false});
    }
  }
}

defineAndMakeJsxFactory(`mp-org-select-modal`, OrgSelectModal);
